module.exports = __webpack_public_path__ + "static/media/secure-site.1172920a.png";